export const homeTabe = {
    "All Projects": {
        "img": require('../img/All Projects.759c9e28.svg'), "color": "LightGrey", "text": "black",
        "Data": [
            {
                "title": "React", "body": "testwordast", "links": ""
            },
            {
                "title": "TestReactTitle", "body": "一个测试的内容", "links": "http://www.baidu.com"
            }
        ]
    },
    "React": {
        "img": require("../img/React.669f1046.svg"), "color": "LightGrey", "text": "black",

        "Data": [
            {
                "title": "React", "body": "testwordast", "links": ""
            },
            {
                "title": "TestReactTitle", "body": "一个测试的内容", "links": "http://www.baidu.com"
            }
        ]
    },
    "React native": {
        "img": require("../img/React.669f1046.svg"), "color": "LightGrey", "text": "black",

        "Data": [
            {
                "title": "React native", "body": "testwordast", "links": ""
            },
            {
                "title": "TestReact native", "body": "一个测试的内容", "links": ""
            }
        ]
    },
    "Flutter": {
        "img": require("../img/flutter.png"), "color": "LightGrey", "text": "black"
    },
    "Java": {
        "img": require("../img/java.svg"), "color": "LightGrey", "text": "black", 
    },
    "Java script": {
        "img": require("../img/JavaScript.d0fcd6f7.svg"), "color": "LightGrey", "text": "black",
    },
    "CSS": {
        "img": require("../img/CSS.svg"), "color": "LightGrey", "text": "black"
    },
    "HTML": {
        "img": require("../img/html.svg"), "color": "LightGrey", "text": "black"
    }
    
}




export const homeBigText = "没有人可以回到过去，重新开始；\n但谁都可以从现在开始，书写一个全然不同的结局！";

